import { useState, useEffect } from 'react'

/**
 * Hook to check feature flags from window globals
 * @param {string} featureName - The name of the feature flag to check
 * @returns {boolean} - The feature flag value (defaults to false if not found)
 */
export default function useFeatureFlag(featureName) {
  const [isEnabled, setIsEnabled] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined' && featureName) {
      const flagValue = window.features?.[featureName]
      setIsEnabled(Boolean(flagValue))
    }
  }, [featureName])

  return isEnabled
}
